<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="6" sm="8">
        <h1 class="text-lg-h2 text-md-h2 text-h4 text-h4">Log in</h1>
        <v-form class="mt-10" method="POST" action="/accounts/login/">
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrftoken" />
          <v-text-field
            label="Email"
            name="username"
            prepend-icon="mdi-email"
            type="text"
          ></v-text-field>

          <v-text-field
            id="password"
            label="Password"
            name="password"
            prepend-icon="mdi-lock"
            type="password"
          ></v-text-field>
          <v-btn large type="submit" class="mt-5" color="primary">Log in</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export default {
  name: "Login",

  data: () => ({
    csrftoken: getCookie("csrftoken")
  })
};
</script>
